module.exports = __webpack_public_path__ + "static/phone-ceb917359236906044974323a3eac360.png";